// Pop-up de campanha (admin: Home → Pop-ups de campanha). Abre após o atraso
// configurado e, depois de fechado (ou do clique no botão), só volta após
// "mostrar de novo após" minutos — controlado por localStorage, por campanha.
const popupCampanha = () => {
  const popup = document.getElementById("popup-campanha");
  if (!popup) return;

  const chave = `popup-campanha-${popup.dataset.id}`;
  const reexibirMs = Number(popup.dataset.reexibir || 0) * 60 * 1000;

  const ler = () => {
    try { return Number(localStorage.getItem(chave)) || 0; } catch { return 0; }
  };
  const gravar = () => {
    try { localStorage.setItem(chave, String(Date.now())); } catch { /* modo privado */ }
  };

  if (Date.now() - ler() < reexibirMs) return;

  const fechar = () => {
    if (popup.hidden) return;
    popup.hidden = true;
    gravar();
  };

  popup.querySelectorAll(".xp-close, .xp-overlay").forEach((botao) =>
    botao.addEventListener("click", fechar)
  );
  popup.querySelector(".xp-cta")?.addEventListener("click", gravar);
  document.addEventListener("keydown", (evento) => {
    if (evento.key === "Escape") fechar();
  });

  // No celular o banner de cookies (AdOpt, z-index máximo) cobriria o botão:
  // espera a pessoa responder ao banner antes de abrir.
  const bannerCookies = () => {
    const banner = document.getElementById("cookie-banner");
    if (!banner) return false;
    const estilo = getComputedStyle(banner);
    return banner.getClientRects().length > 0 && estilo.visibility !== "hidden" && estilo.opacity !== "0";
  };
  const celular = window.matchMedia("(max-width: 600px)");

  const abrir = () => {
    if (celular.matches && bannerCookies()) {
      setTimeout(abrir, 500);
      return;
    }
    popup.hidden = false;
    popup.querySelector(".xp-close")?.focus({ preventScroll: true });
  };

  setTimeout(abrir, Number(popup.dataset.atraso || 0) * 1000);
};

export default popupCampanha;
